import { apiClient } from '../utils';
import { handleError } from './';

/**
 * بدست آوردن ریجن و نیبرهود با استفاده از عرض و طول جغرافیایی
 * @param coords - آرایه کوردینیت لوکیشن
 * @example
 * getRegionOfLocation(["LN", "LT"]);
 * region: {
 *   name: "REGION NAME"
 *   parent: "PARENT STATE"
 *   point: ["LONGITUDE", "LATITUDE"]
 *   type: "REGION TYPE"
 *   _id: "REGION ID"
 * }
 */
const getRegionOfLocation = async ([ln, lt]: [Number, Number]) => {
  try {
    const { result } = await apiClient.post('/region/ofLocation', {
      data: { ln, lt },
    });
    return result.region;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
export { getRegionOfLocation };
